

//------ cspdsubgroup1 -----------------
import React from 'react';
import { genURL } from '../../../_getjson';
import axios from 'axios';
import { DataGrid, GridToolbarQuickFilter, GridToolbar, GridToolbarContainer, } from '@mui/x-data-grid';
import { Box, Stack } from '@mui/material';

export default function ProductTypeList(props) {
    const [loading, setLoading] = React.useState(true)
    const [data, setData] = React.useState([])
    const [selectionModel, setSelectionModel] = React.useState([]);
    const [searchData, setSearchData] = React.useState("")

    React.useEffect(() => {
        getData();
        return () => {
        }
    }, [])


    React.useEffect(() => {
        getData();
        return () => {
        }
    }, [searchData])


    const getData = async () => {
        let rows = []
        setLoading(true)
        let url = ""
        if (searchData.length > 0) {
            url = "CSPDSUBGROUP1/searchData?txt=" + searchData
        }
        else {
            url = "CSPDSUBGROUP1/getAll?"
        }
        await axios.get(genURL(url)).then(e => {
            for (let index = 0; index < e.data.length; index++) {
                rows.push({ id: index + 1, code: e.data[index].CODE, name: e.data[index].MYNAMETH })
            }
        })
        await console.log(rows);
        await setLoading(false)
        await setData(rows)

    }

    const columns = [
        { field: 'id', headerName: 'ID', width: 90 },
        {
            field: 'code',
            headerName: 'รหัส',
            width: 30,
            editable: false,
            flex: 1
        },
        {
            field: 'name',
            headerName: 'ชื่อ/คำอธิบาย',
            width: 150,
            editable: false,
            flex: 1
        },
    ];

    const handleDoubleClick = (e) => {
        // console.log(selectionModel); 
        // f
        let result = []
        if (selectionModel.length > 0) {
            result = data.filter((elem) => {
                return selectionModel.some((ele) => {
                    return ele === elem.id
                });
            });
        } else {
            result.push(e.row)
        }
        props.resultData(result)
    }

    const searchInputKeyUp = (e) => {

        if (e.key === "Enter") {
            setSearchData(e.target.value)
        }

    }


    const CustomToolbar = () => {
        return (
            <>

                <GridToolbarContainer id={`GridToolbarContainers`} >

                    <GridToolbarQuickFilter />
                    {/* <Stack direction="row" spacing={2}>
                        <TextField id="searchinput-basic" label="คำค้นหา" variant="standard" onKeyUp={e => searchInputKeyUp(e)} size='small'
                            sx={{
                                fontFamily: "Customfont !important"
                            }} />
                    </Stack> */}
                </GridToolbarContainer >
            </>
        );
    }


    return (

        <Box sx={{ height: 400, width: '100%', mt: 2 }}>
            {loading == true ? "กำลังโหลด..." :
                <DataGrid
                    rows={data}
                    columns={columns}
                    sx={{
                        fontFamily: "Customfont !important"
                    }}
                    disableColumnFilter
                    disableColumnSelector
                    disableDensitySelector
                    initialState={{
                        pagination: {
                            paginationModel: {
                                pageSize: 10,
                            },
                        },
                        // filter: {
                        //     filterModel: {
                        //         items: [],
                        //         quickFilterValues: ['quick', 'filter'],
                        //     },
                        // },
                    }}
                    pageSizeOptions={[10]}
                    // checkboxSelection
                    // disableSelectionOnClick
                    // onSelectionModelChange={(newSelectionModel) => {
                    //     setSelectionModel(newSelectionModel);
                    // }}
                    selectionModel={selectionModel}
                    onRowDoubleClick={e => handleDoubleClick(e)}
                    //  onRowClick={e => handleClick(e)}
                    experimentalFeatures={{ newEditingApi: true }}
                    components={{
                        Toolbar: CustomToolbar,
                        // LoadingOverlay: LinearProgress,
                    }}
                />}
        </Box>

    )

}